var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 0,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.4,
    y: 0,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 0,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 0,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#C8922A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20.7,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 20.7,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 41.4,
    y: 20.7,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 20.7,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 20.7,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 41.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 41.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 41.4,
    y: 41.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 41.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 41.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 62.1,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 62.1,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 41.4,
    y: 62.1,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 62.1,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 62.1,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 82.8,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 82.8,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 41.4,
    y: 82.8,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 82.8,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 82.8,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.a888254b8d83f853b53737bd0eb3d35d.svg";
export { ForwardRef as ReactComponent };